import models from '../helpers/data-models';

export default {

  state: {},

  getters: {

    models() {
      return models;
    },

    locations(state, getters, rootState) {
      const blacklist = [
        'Along Digital 395 Route',
        'Regional Service',
      ];

      const locations = rootState.data.serviceAreas
        .map(item => item.properties.Loation)
        .filter(item => !blacklist.includes(item));

      return locations;
    }

  },

  mutations: {},

  actions: {},

};
